/**
 * @generated SignedSource<<b66c71f1e6642b13b378344a21760164>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetails_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsAbout_user" | "PdpRespSidebarDetailsCustomization_user" | "PdpRespSidebarDetailsPromise_user" | "PdpRespSidebarDetailsSeller_user" | "PdpRespSidebarDetailsShipping_user">;
  readonly " $fragmentType": "PdpRespSidebarDetails_user";
};
export type PdpRespSidebarDetails_user$key = {
  readonly " $data"?: PdpRespSidebarDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetails_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsAbout_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsSeller_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsPromise_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsShipping_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsCustomization_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "beccb4d994939790752ad4d47462a00e";

export default node;
